import React, { Component } from "react";
import { connect } from "react-redux";
import instance from "../../store/actions/instance";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import Button from "@material-ui/core/Button";
import moment from "moment";
import { timeConvert } from "../Branches/ContactPageTools";
import {
  add_to_cart,
  clearUsedComponents,
  remove_from_cart,
} from "../../store/actions";
import {
  check_required_options,
  getAllowableInventory,
} from "../../store/actions/store";
import HelpIcon from "@material-ui/icons/Help";
import Popover from "@material-ui/core/Popover";
import { preciseNumber } from "../../store/reducers/cart";
import { getParentCategories } from "../Menu/Helpers";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import Carousel from "react-material-ui-carousel";
import PreviousOrderAgain from "./index";
import PreviousOrderAgainCard from "./PreviousOrderAgainCard";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import {
  getProductInventory,
  getProductUsedComponents,
} from "../../store/reducers/store";
import OrdersV2 from "../PastOrders/OrdersV2";
import { isStorefrontFoundationEnabled } from "../Storefront/featureFlags";
import { freshReorderProduct, reorderCheckoutPath, validateReorderProducts } from "../PastOrders/reorderFlow";

export function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class index extends Component {
  state = {
    loading: false,
    pastOrders: [],
    search: "",
    searchLoading: false,
    reorderLoading: false,
    tooltipOpen: false,
    alertOpen: false,
    activeItemIndex: 0,
    reorderError: false,
  };

  handleFetchOrder = () => {
    const pastOrdersIds = this.props.pastOrders.slice(-3).sort((a, b) => b - a);
    const pastOrdersForReorderIds = this.props.partOrdersForReOrder
      .map((order) => order.id)
      .sort((a, b) => b - a);

    if (this.props.pastOrders.length > 0) {
      if (
        JSON.stringify(pastOrdersIds) !==
        JSON.stringify(pastOrdersForReorderIds)
      ) {
        this.fetchPastOrders();
      }
    }
  };
  componentDidMount = () => {
    this.handleFetchOrder();
  };
  componentDidUpdate = (prevProps) => {
    if (prevProps.pastOrders.length !== this.props.pastOrders.length) {
      this.handleFetchOrder();
    }
  };

  getTotalPrice = (sum, options) => {
    let selected_option = {};
    let optionSum = 0;
    const quantity = 1;

    let quantityExcludedOptionsTotal = 0;

    for (let key of Object.keys(options)) {
      optionSum = 0;
      selected_option = options[key].selectedOptions;

      if (isEmpty(selected_option)) delete options[key];
      else {
        for (let selected_key of Object.keys(selected_option)) {
          optionSum +=
            selected_option[selected_key].quantity *
            selected_option[selected_key].price;
        }
        if (options[key].quantityExclusive) {
          quantityExcludedOptionsTotal = preciseNumber(
            quantityExcludedOptionsTotal + optionSum
          );
        } else {
          sum += optionSum * quantity;
        }
      }
    }

    return {
      total_price: preciseNumber(sum),
      quantityExcludedOptionsTotal: preciseNumber(quantityExcludedOptionsTotal),
    };
  };

  async fetchPastOrders(search) {
    try {
      let branch_id = this.props.branch.branch;
      let used_components = this.props.used_components;
      const res = await instance.post(`/get_past_orders/`, {
        promises: this.props.pastOrders.slice(-3),
        is_search: !!search,
        branch_id: branch_id,
        used_components: used_components,
        fetch_items: true,
        from_previous_orders: true,
      });
      this.props.storePastOrderProducts(res.data);
      this.props.fetchPastOrderForReorder(res.data);
    } catch (err) {
      console.error(err);
    }
  }

  EmptyCart = () => {
    const length = this.props.cart.length;
    for (let i = 0; i < length; i++) {
      this.props.remove_from_cart(0, this.props.cart[0]);
    }
    this.props.clearUsedComponents();
  };
  getOptions = (options, store_product, itemQuantity) => {
    const { used_components } = this.props;
    let selectedOptions = {};
    let optionUsedComponents = {};
    for (let i = 0; i < options.length; i++) {
      const option = options[i];

      const choice = option.product_option;
      const group = option.group
        ? choice.option_id + "-" + option.group
        : choice.option_id;
      let store_choice = null;
      let store_option = null;
      if (!isEmpty(store_product.options)) {
        store_option = store_product.options.find(
          (G) => G.id === parseInt(group)
        );
        if (
          option.group &&
          !store_product.options_groups.some(
            (og) => og.id == parseInt(option.group)
          )
        ) {
          store_option = null;
        }
        if (!store_option) return "remove";
        store_choice = store_option.choices.find((o) => o.id === choice.id);
      }
      if (!store_choice) return "remove";

      const selectedGroupQuantity = selectedOptions[group]?.selected || 0;
      const selectedChoiceQuantity =
        selectedOptions[group]?.selectedOptions?.[choice.id]?.quantity || 0;
      const optionQuantity = Number(option.quantity) || 0;
      const optionRemaining = Math.max(
        (store_option.maximum || Infinity) - selectedGroupQuantity,
        0
      );
      const choiceRemaining = Math.max(
        (store_choice.maximum || Infinity) - selectedChoiceQuantity,
        0
      );
      const rawAllowedQuantity = Math.max(
        Math.min(optionQuantity, optionRemaining, choiceRemaining),
        0
      );
      const increments =
        store_option.multiple && store_option.maximum !== 1
          ? Math.max(parseInt(store_choice.increments) || 1, 1)
          : 1;
      const allowedQuantity =
        Math.floor(rawAllowedQuantity / increments) * increments;

      if (allowedQuantity <= 0) continue;

      if (store_choice.inventory !== null && store_choice.related_product) {
        const modifierQuantity =
          (!store_option.quantity_exclusive &&
            allowedQuantity * itemQuantity) ||
          allowedQuantity;

        optionUsedComponents[store_choice.related_product.id] =
          (optionUsedComponents[store_choice.related_product.id] || 0) +
          modifierQuantity;

        const usedAmount =
          (this.props.used_components[store_choice.related_product.id] || 0) +
          optionUsedComponents[store_choice.related_product.id];

        if (
          getProductInventory(store_choice.related_product, used_components) -
            usedAmount <
          0
        ) {
          return "remove";
        }
      }

      if (!selectedOptions[group]) {
        selectedOptions[group] = {
          selected: allowedQuantity,
          quantityExclusive: store_option.quantity_exclusive,
          selectedOptions: {
            [choice.id]: {
              quantity: allowedQuantity,
              price: store_choice.price,
              related_product: store_choice.related_product,
              modifier: store_choice.modifier,
              maxInventory: store_choice.inventory,
              preparationTime: store_choice.preparation_time,
            },
          },
        };
      } else {
        selectedOptions[group].selected += allowedQuantity;
        selectedOptions[group].selectedOptions[choice.id] = {
          quantity: selectedChoiceQuantity + allowedQuantity,
          price: store_choice.price,
          related_product: store_choice.related_product,
          modifier: store_choice.modifier,
          maxInventory: store_choice.inventory,
          preparationTime: store_choice.preparation_time,
        };
      }
    }
    if (check_required_options(store_product, selectedOptions)) {
      return selectedOptions;
    }
    return "remove";
  };
  FindProduct = (pitem) => {
    const { used_components } = this.props;
    try {
      let item = pitem.product;

      let store_product = this.props.store.categories.find(
        (category) => category.id === item.category_id
      );

      if (isStorefrontFoundationEnabled(this.props.settings)) {
        store_product = freshReorderProduct(pitem);
      } else if (pitem.parent_id) {
        store_product = store_product.products
          .find((parent) => parent.id === pitem.parent_id)
          .children.find((product) => product.id === pitem.product_id);
      } else {
        store_product = store_product.products.find(
          (product) => product.id === pitem.product_id
        );
      }
      if (store_product) {
        if (["produced", "digital"].includes(store_product.type_of_product)) {
          return { store_product, quantity: pitem.quantity };
        } else if (
          ["stocked", "composite"].includes(store_product.type_of_product) &&
          getProductInventory(store_product, used_components) >=
            store_product.min_addable_quantity
        ) {
          let inventory = pitem.quantity;
          const productAvailableInventory = getProductInventory(
            store_product,
            used_components
          );

          if (pitem.quantity > productAvailableInventory) {
            inventory = getAllowableInventory(
              productAvailableInventory,
              store_product.increments,
              store_product.min_addable_quantity
            );
          }
          if (inventory < store_product.min_addable_quantity) {
            return false;
          }

          return {
            store_product,
            quantity: inventory,
          };
        } else if (store_product.type_of_product === "bookable") {
          let inventory = store_product.booking_slots.find(
            (slot) => slot.id === pitem.booking_original_slot_id
          ).inventory;
          if (inventory !== 0) {
            return {
              store_product,
              quantity: Math.min(pitem.quantity, inventory),
            };
          }
        }
      }
    } catch (err) {
      return false;
    }
    return false;
  };

  handleReOrder = async (p) => {
    const { address, store, cart, settings } = this.props;
    const reorderBranch = this.props.branch;
    const reorderTime = this.props.deliveryTime;
    if (this.state.reorderLoading) return;
    try {
      this.setState({ reorderLoading: true, reorderError: false, alertOpen: false });
      let branch_id = this.props.branch.branch;
      // Reorder replaces the old cart, so check the new items without reserving
      // inventory for the items that are about to leave it.
      let used_components = {};
      const res = await instance.post(`/get_past_orders/`, {
        promises: p.tracking_id,
        is_search: true,
        branch_id: branch_id,
        used_components: used_components,
        fetch_items: true,
      });
      if (String(branch_id || "") !== String(this.props.branch.branch || "") ||
          String(address?.area || "") !== String(this.props.address?.area || "") ||
          address?.selectedDeliveryType !== this.props.address?.selectedDeliveryType) throw new Error("Order location changed during reorder");
      if (isStorefrontFoundationEnabled(settings) && res.data[0]?.items && !res.data[0].items.some(freshReorderProduct)) {
        this.setState({ reorderLoading: false, alertOpen: true });
        return;
      }
      try {
        if (!isStorefrontFoundationEnabled(settings) && res.data[0].lat && res.data[0].lng)
          this.props.modifyAddress({
            lat: parseFloat(res.data[0].lat),
            lng: parseFloat(res.data[0].lng),
          });
      } catch (e) {}

      this.props.storePastOrderProducts(res.data);
      p.items = res.data[0].items;
    } catch (err) {
      this.setState({ reorderLoading: false, reorderError: true });
      return;
    }
    let item = null;

    const candidates = [];
    let nonMingledCategory = null;
    let addedItem = false;
    for (let i = 0; i < p.items.length; i++) {
      item = p.items[i];
      let { store_product, quantity } = this.FindProduct(item);

      if (store_product) {
        if (
          store_product.pickup_only &&
          (!address || address.selectedDeliveryType !== 1)
        ) {
          continue;
        }
        let options = this.getOptions(item.options, store_product, quantity);
        let parentCategories = null;
        if (store_product.category_is_child) {
          parentCategories = getParentCategories(
            store_product.category_id,
            store.categories
          );
        }

        if (nonMingledCategory) {
          if (
            store_product.category_id !== nonMingledCategory &&
            parentCategories?.nonMingledParentCategory !== nonMingledCategory
          ) {
            continue;
          }
        } else if (addedItem) {
          if (
            store_product.category_no_mingling ||
            parentCategories?.nonMingledParentCategory
          ) {
            continue;
          }
        } else {
          if (parentCategories?.nonMingledParentCategory) {
            nonMingledCategory = parentCategories?.nonMingledParentCategory;
          } else if (store_product.category_no_mingling) {
            nonMingledCategory = store_product.category_id;
          }
        }

        if (options !== "remove") {
          let product = {
            id: store_product.id,
            quantity: quantity,
            category: store_product.category,
            category_id: store_product.category_id,
            components: store_product.components,
            options: options,
            booking_slot: item.booking_original_slot_id,
            parent: store_product.parent,
            ...this.getTotalPrice(store_product.price, options),
            price: store_product.price,
            is_delivered: store_product.is_delivered,
            charge_delivery: store_product.charge_delivery,
            special_request: item.special_remarks,
            preparation_time: store_product.preparation_time,
            preparation_time_threshold:
              store_product.preparation_time_threshold,
            pickup_only: store_product.pickup_only,
            delivery_only: store_product.delivery_only,
            is_preordered: false,
            extraFields: {},
            name: store_product.name,
            category_is_child: store_product.category_is_child,
            category_no_mingling: store_product.category_no_mingling,
            parentCategories: parentCategories,
            excludeVat: store_product.exclude_from_vat,
            cash_only:
              settings.enable_cash &&
              settings.allow_cash &&
              settings.enable_online_payments &&
              settings.enable_payments
                ? store_product.cash_only
                : false,
            credit_only:
              settings.enable_cash &&
              settings.allow_cash &&
              settings.enable_online_payments &&
              settings.enable_payments
                ? store_product.credit_only
                : false,
            // productUsedComponents: getProductUsedComponents(product),
          };
          candidates.push(product);
          addedItem = true;
        }
      } else {
        continue;
      }
    }
    try {
      if (!await validateReorderProducts(candidates, { settings, address, branch: reorderBranch, deliveryTime: reorderTime })) {
        this.setState({ reorderLoading: false, alertOpen: true });
        return;
      }
      if (address !== this.props.address || reorderBranch !== this.props.branch || reorderTime !== this.props.deliveryTime) throw new Error("Order context changed");
      this.EmptyCart();
      for (const product of candidates) await this.props.AddToCart(product);
    } catch (error) {
      this.setState({ reorderLoading: false, reorderError: true });
      return;
    }
    this.setState({ reorderLoading: false });
    if (!this.props.cart.length) {
      this.setState({ alertOpen: true });
    } else {
      this.props.history.replace(reorderCheckoutPath(settings));
    }
  };

  render() {
    const { themeColor, language, settings } = this.props;
    if (isStorefrontFoundationEnabled(settings)) return settings.is_menu ? null : <OrdersV2 compact
      orders={this.props.partOrdersForReOrder || []} language={language} settings={settings} history={this.props.history}
      address={this.props.address} branch={this.props.branch} cartCount={this.props.cart.length} busy={this.state.reorderLoading}
      reorderError={this.state.reorderError} onReorder={this.handleReOrder}
      alert={this.state.alertOpen && <p className="orders-v2__error" role="alert">{language === "arabic" ? "لا تتوفر منتجات هذا الطلب للخيارات الحالية. جرّب موقعاً آخر أو تصفح القائمة." : "These items aren’t available for your current order options. Try another location or explore the menu."}</p>} />;
    return (
      <div
        style={{
          paddingTop: 20,
        }}
      >
        <Snackbar
          open={this.state.alertOpen}
          autoHideDuration={3000}
          onClose={() => this.setState({ alertOpen: false })}
          classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
        >
          <Alert
            onClose={() => this.setState({ alertOpen: false })}
            severity="error"
          >
            {language === "english"
              ? "Order cant be placed because all products are not available"
              : "لا يمكن إعادة الطلب لأن جميع المنتجات لم تعد متوفره"}
          </Alert>
        </Snackbar>
        {this.props.partOrdersForReOrder?.filter(
          (order) => !order.has_service && order.items.length > 0
        ).length > 0 && (
          <div>
            <h4
              style={{
                textAlign: language === "english" ? "left" : "right",
                marginLeft: language === "english" ? 15 : 0,
                marginRight: language === "english" ? 0 : 15,
                paddingTop: 17,
                fontWeight: 700,
                color: "#000000",
                fontSize: 16,
                fontFamily: "Quicksand",
              }}
            >
              {language === "english" ? "Order again" : "اعادة الطلب"}
            </h4>
            <div
              className={"hide-scrollbar"}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0 15px",
                marginBottom: 19,
                overflowX: "scroll",
                overflowY: "hidden",
                whiteSpace: "nowrap",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                flexDirection: language === "arabic" ? "row-reverse" : "row",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: language === "arabic" ? "row-reverse" : "row",
                }}
              >
                {this.props.partOrdersForReOrder
                  .filter(
                    (order) => !order.has_service && order.items.length > 0
                  )
                  .map((order) => (
                    <PreviousOrderAgainCard
                      order={order}
                      handleReorder={() => this.handleReOrder(order)}
                      themeColor={this.props.themeColor}
                    />
                  ))}
                {this.props.pastOrders.length > 3 && (
                  <div
                    onClick={() => this.props.history.push("/track/previous")}
                    style={{
                      width: 160,
                      height: 100,
                      backgroundColor: themeColor,
                      borderRadius: 5,
                      marginRight: 8,
                      display: "flex",
                      flexDirection:
                        language === "arabic" ? "row-reverse" : "row",
                      padding: 8,
                      justifyContent: "center",
                      alignItems: "center",
                      color: "white",
                      fontWeight: 700,
                      cursor: "pointer",
                    }}
                  >
                    {language === "english" ? "View all" : "عرض الكل"}
                    {language === "english" ? (
                      <NavigateNextIcon />
                    ) : (
                      <NavigateBeforeIcon />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    store: state.store.store,
    pastOrders: state.PastOrders.pastOrders,
    themeColor: state.store.store.settings.dark,
    language: state.store.language,
    cart: state.cart.cart,
    settings: state.store.store.settings,
    address: state.customers?.address,
    branch: state.branch,
    deliveryTime: state.deliveryTime,
    used_components: state.store.used_components,
    non_mingled_category: state.cart.non_mingled_category,
    partOrdersForReOrder: state.PastOrders.partOrdersForReOrder,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    AddToCart: (product, history) => dispatch(add_to_cart(product, history)),
    remove_from_cart: (item_index, item) =>
      dispatch(remove_from_cart(item_index, item)),
    storePastOrderProducts: (pastOrders) =>
      dispatch({ type: "STORE_PAST_ORDER_PRODUCTS", payload: pastOrders }),
    addToPastOrders: (newID) =>
      dispatch({ type: "ADD_TO_PAST_ORDERS", payload: newID }),
    clearUsedComponents: () => dispatch(clearUsedComponents()),
    fetchPastOrderForReorder: (data) =>
      dispatch({ type: "FETCH_TO_PAST_ORDERS_FOR_REORDER", payload: data }),
    modifyAddress: (address) =>
      dispatch({ type: "MODIFY_ADDRESS", payload: address }),
  };
};

export { index as PreviousOrderAgainController };
export default connect(mapStateToProps, mapDispatchToProps)(index);
